var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#232732",
  fillRule: "evenodd",
  d: "m2.646 4.354.708-.708L6 6.293l2.646-2.647.708.708L6 7.707 2.646 4.354Z",
  clipRule: "evenodd"
})));
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjY0NjQ4IDQuMzUzNTlMMy4zNTM1OSAzLjY0NjQ4TDYuMDAwMDQgNi4yOTI5M0w4LjY0NjQ4IDMuNjQ2NDhMOS4zNTM1OSA0LjM1MzU5TDYuMDAwMDQgNy43MDcxNEwyLjY0NjQ4IDQuMzUzNTlaIiBmaWxsPSIjMjMyNzMyIi8+Cjwvc3ZnPgo=";